import styles from './product-usage-chart.module.scss';
import WebkuaChart from '../webkua-chart/webkua-chart';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface ProductUsageChartProps { }

export interface ChartData {
  labels: string[];
  datasets: any[];
}

export function ProductUsageChart(props: ProductUsageChartProps) {
  const { t } = useTranslation();
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  return <WebkuaChart
    title={t("app.licenseUsage")}
    startDate={startOfMonth}
    endDate={today}
    url='charts/licenseUtilization'
  />

}

export default ProductUsageChart;
